<template>
  <div :class="fieldClass">
    <template v-if="field.type === 'textarea'">
      <label :for="field.name" v-if="field.showLabel !== false">{{
        fieldLabel
      }}</label>
      <textarea
        @input="onInput"
        :id="field.name"
        :name="field.name"
        :value="newValue"
        :placeholder="field.name"
        :disabled= true
      >
      </textarea>
    </template>
    <template v-else>
      <label
        :for="field.name"
        v-if="field.showLabel !== false && field.type === 'date'"
        >{{ fieldLabel }}</label
      >
      <!--            <input-->
      <!--                    @input="onInput"-->
      <!--                    value="16:32:55"-->
      <!--                    :placeholder="fieldLabel"-->
      <!--                    :type="field.type ? field.type : 'text'"-->
      <!--                    :required="field.required"-->
      <!--                    :id="field.name"-->
      <!--                    :step= "field.type == 'time' ? '900' : 'any'">-->
      <input
        @input="onInput"
        v-if="field.type === 'date'"
        :value="newValue"
        :placeholder="fieldLabel"
        :type="'date'"
        :required="field.required"
        :id="field.name"
      />
      <vue-timepicker
        manual-input
        @input="onInput"
        v-if="field.type !== 'date' && field.type !== 'select' && field.type !== undefined
"
        :minute-interval="15"
        :value="newValue"
        :placeholder="fieldLabel"
        :type="field.type ? field.type : 'text'"
        :id="field.name"
        input-width="200px"
      ></vue-timepicker>
      <!--            <select name="cars" class="custom-select"-->
      <!--                    v-if="field.type === 'select'" :id="field.name"-->
      <!--                    @change="onChangeSelect($event)">-->
      <!--                <option class="option" selected>You can choose time range</option>-->
      <!--                <option class="option" value="1">1 hour</option>-->
      <!--                <option class="option" value="2">2 hours</option>-->
      <!--                <option class="option" value="3">3 hours</option>-->
      <!--                <option class="option" value="4">4 hours</option>-->
      <!--                <option class="option" value="5">5 hours</option>-->
      <!--                <option class="option" value="6">6 hours</option>-->
      <!--                <option class="option" value="7">7 hours</option>-->
      <!--                <option class="option" value="8">8 hours</option>-->
      <!--                <option class="option" value="9">9 hours</option>-->
      <!--                <option class="option" value="10">10 hours</option>-->
      <!--                <option class="option" value="11">11 hours</option>-->
      <!--                <option class="option" value="12">12 hours</option>-->
      <!--                <option class="option" value="24">24 hours</option>-->

      <!--            </select>-->
    </template>
  </div>
</template>

<script>
import moment from "moment";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

export default {
  name: "EventDialogInput",
  components: { VueTimepicker },
  props: {
    value: [Date, String, Number, Boolean, Array, Object],
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newValue: this.value
    };
  },
  beforeMount() {
    //  Date workaround
    if (this.field.type === "date" && this.value) {
      this.newValue = moment(this.value)
        .format()
        .slice(0, 10);
    }

    //  Time workaround
    if (
      this.field.type === "time" &&
      this.value &&
      this.field.name == "startTime"
    ) {

      // let start = moment();
      // let remainder = start.minute() % 15;
      // let dateTime;
      // if (remainder < 7) {
      //   dateTime = moment(start)
      //     .subtract(remainder, "minutes")
      //     .format();
      // } else {
      //   remainder = 15 - (start.minute() % 15);
      //   dateTime = moment(start)
      //     .add(remainder, "minutes")
      //     .format();
      // }

      this.newValue = moment(this.value)
        .format()
        .slice(11, 19);
    }
    if (
      this.field.type === "time" &&
      this.value &&
      this.field.name == "endTime"
    ) {
        // let start = moment();
        // let remainder = start.minute() % 15;
        // let dateTime;
        // if (remainder < 7) {
        //     dateTime = moment(start)
        //         .subtract(remainder, "minutes")
        //         .format();
        // } else {
        //     remainder = 15 - (start.minute() % 15);
        //     dateTime = moment(start)
        //         .add(remainder, "minutes")
        //         .format();
        // }
      this.newValue = moment(this.value)
        .add(15, "m")
        .format()
        .slice(11, 19);
    }
  },
  methods: {
    onInput(event) {
      if(typeof event == "string") {
        this.$nextTick(() => {
          this.newValue = event;
        });
      } else  if(typeof event == "object"){
        this.$nextTick(() => {
          this.newValue = event.target.value;
        });
      }




        // this.newValue = event;
        // this.newValue = event.target.value;

      // });
    },
    // onChangeSelect(event) {
    //     if(event.target.value.length < 7) {
    //         let startInput = document.getElementById("startTime").value
    //         if (startInput.length != 0) {
    //             let hoursToChange = startInput.slice(0, 2)
    //             let minutesToChange = startInput.slice(3, 5)
    //             let hoursNew = parseInt(hoursToChange) + parseInt(event.target.value)
    //             if (hoursNew >= 24) {
    //                 hoursNew = 23
    //             }

    //             let newEndValue = hoursNew + ":" + minutesToChange

    //             document.getElementById("endTime").value = newEndValue
    //         }
    //     }
    // },
    onSelectChange(event) {
      // let startInput = document.getElementById("startTime")
      // let endInput = document.getElementById("endTime")
      //
      // endInput.value = "15:30"
    }
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    newValue(value) {
      let res = value;

      if (this.field.type === "time") {
        res = moment(this.newValue, "HH:mm");
      }
      this.$emit("input", res);
    }
  },
  computed: {
    isCheckOrRadio() {
      return this.field.type === "radio" || this.field.type === "checkbox";
    },
    fieldLabel() {
      return this.field.label ? this.field.label : this.field.name;
    },
    fieldClass() {
      if (this.overrideInputClass) return this.inputClass;

      let classes = ["v-cal-input", this.inputClass];

      if (this.isCheckOrRadio) {
        if (!this.field.choices) {
          classes.push("is-inline");
          classes.push("is-" + this.field.type);
        } else {
          classes.push("v-cal-input-group");
        }
      }

      return classes.join(" ");
    }
  }
};
</script>

<style scoped></style>
